/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Picture_File_TypesInputs */

const en_admin_resource_form_picture_file_types = /** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.JPG .PNG .GIF (800 × 450px)`)
};

const de_admin_resource_form_picture_file_types = /** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.JPG .PNG .GIF (800 × 450px)`)
};

const es_admin_resource_form_picture_file_types = /** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.JPG .PNG .GIF (800 × 450px)`)
};

const fr_admin_resource_form_picture_file_types = /** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.JPG .PNG .GIF (800 × 450px)`)
};

/** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */
const it_admin_resource_form_picture_file_types = en_admin_resource_form_picture_file_types;

/** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */
const pt_br2_admin_resource_form_picture_file_types = en_admin_resource_form_picture_file_types;

/** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */
const pl_admin_resource_form_picture_file_types = en_admin_resource_form_picture_file_types;

/** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */
const hu_admin_resource_form_picture_file_types = en_admin_resource_form_picture_file_types;

/** @type {(inputs: Admin_Resource_Form_Picture_File_TypesInputs) => LocalizedString} */
const ro_admin_resource_form_picture_file_types = en_admin_resource_form_picture_file_types;

/**
* | output |
* | --- |
* | ".JPG .PNG .GIF (800 × 450px)" |
*
* @param {Admin_Resource_Form_Picture_File_TypesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_picture_file_types = /** @type {((inputs?: Admin_Resource_Form_Picture_File_TypesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Picture_File_TypesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_picture_file_types(inputs)
	if (locale === "de") return de_admin_resource_form_picture_file_types(inputs)
	if (locale === "es") return es_admin_resource_form_picture_file_types(inputs)
	if (locale === "fr") return fr_admin_resource_form_picture_file_types(inputs)
	if (locale === "it") return it_admin_resource_form_picture_file_types(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_picture_file_types(inputs)
	if (locale === "pl") return pl_admin_resource_form_picture_file_types(inputs)
	if (locale === "hu") return hu_admin_resource_form_picture_file_types(inputs)
	return ro_admin_resource_form_picture_file_types(inputs)
});
export { admin_resource_form_picture_file_types as "admin.resource_form.picture_file_types" }